import ActionsList from "core/actions/Actions.list";
import { actionCoreApi } from "core/utils/api";
import { actionErrorNotifier } from "core/utils/helpers";
import HTTPUrlHelper from "shared/helpers/HTTPUrlHelper";

export const fetchRoles = (filters?: string) =>
  actionErrorNotifier(actionCoreApi(
    ActionsList.FetchRoles,
    filters ?  HTTPUrlHelper.getRolesAPI() + "?" + filters : HTTPUrlHelper.getRolesAPI()
  ))